module.exports = __webpack_public_path__ + "static/media/user-red-icon.6588e196.svg";